import quoteService from "services/quote.service";

export const getRfqData = ({
  setLoading,
  setPercentage,
  setRfqData,
  setErrorMessage,
  setEmptyState,
  state
}) => {
  setLoading(true);
  setPercentage(0);
  setRfqData({});

  const onDownloadProgress = (progressEvent) => {
    const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
    setPercentage(progress);
  };

  let onlyMy = state?.dispatched && state.dispatched

  quoteService.getRFQ(onDownloadProgress, onlyMy).then(
    (response) => {
      setRfqData(response);
      setLoading(false);
    },
    ({ response }) => {
      setErrorMessage(response.data.error);
      setEmptyState(true);
    },
  );
};

export const getRfqDataWithId = ({
  setLoading,
  setPercentage,
  setRfqData,
  setErrorMessage,
  setEmptyState,
  rfqId, 
  take, 
  state
}) => {
  setLoading(true);
  setPercentage(0);
  setRfqData({});
  let onlyMy = state?.dispatched && state.dispatched

  const onDownloadProgress = (progressEvent) => {
    const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
    setPercentage(progress);
  };
  quoteService.getRFQWithId(onDownloadProgress, rfqId, !take, onlyMy).then(
    (response) => {
      setRfqData(response);
      setLoading(false);
    },
    ({ response }) => {
      setErrorMessage(response.data.error);
      setEmptyState(true);
    },
  );
};

export const skipRfqData = ({
  id,
  setErrorModal,
  setErrorMessage,
  setLoading,
  setPercentage,
  setRfqData,
  setDisabled,
  setEmptyState,
  state
}) => {

  quoteService.skipRFQ(id).then(
    ({ status }) => {
      if (status === 200) {
        getRfqData({ setLoading, setPercentage, setRfqData, setEmptyState, state });
        setDisabled(false);
      }
    },
    ({ response }) => {
      const { data } = response;
      setDisabled(false);
      setErrorModal((prev) => ({ ...prev, state: true }));
      setErrorMessage(data.error);
    },
  );
};

export const takeRfqData = ({
  id,
  setErrorModal,
  setErrorMessage,
  setAccepted,
  setDisabled,
  rfqData, 
}) => {  
  quoteService.takeRFQ(id).then(
    ({ status, data }) => {
      if (status === 200) {
        if(rfqData.source === "syl_posted_orders") {
          quoteService.sendMsg(data?.chat_message)
        }
        setAccepted(true);
        setDisabled(false);
      }
    },
    (error) => {
      const errorMessage = error?.response?.data?.error || "Network error. Please check your connection and try again.";
      setDisabled(false);
      setErrorModal({ state: true, type: "withButtonsGroup" });
      setErrorMessage(errorMessage);
    },
  );
};

export const setNoOptions = ({
  id,
  setErrorModal,
  setErrorMessage,
  setLoading,
  setPercentage,
  setRfqData,
  setAccepted,
  setDisabled,
  setEmptyState,
  state
}) => {
  quoteService.noOptions(id).then(
    ({ status }) => {
      if (status === 200) {
        getRfqData({ setLoading, setPercentage, setRfqData, setEmptyState, state });
        setAccepted(false);
        setDisabled(false);
      }
    },
    (error) => {
      const errorMessage = error?.response?.data?.error || "Network error. Please check your connection and try again.";
      setDisabled(false);
      setAccepted(false);
      setErrorModal((prev) => ({ ...prev, state: true }));
      setErrorMessage(errorMessage);
    },
  );
};

export const getBidDetailsData = ({ setBidDetailsData, selectedBid, setLoading }) => {
  setBidDetailsData({});
  setLoading(true);
  const fetchBidDetails = async () => {
    try {
      const data = await quoteService.getBidsDetails(selectedBid);
      setBidDetailsData(data);
      setLoading(false);
    } catch (error) {
      console.error("Error getting data:", error);
    }
  };
  fetchBidDetails();
};

export const getByOrderIdData = ({ setByOrderIdData, showByOrderId, setLoading, setShowByOrderId }) => {
  setByOrderIdData({});
  setLoading(true);
  const fetchByOrderId = async () => {
    try {
      const data = await quoteService.getByOrderId(showByOrderId);
      setByOrderIdData(data);
      setLoading(false);
      setShowByOrderId(false)
    } catch (error) {
      console.error("Error getting data:", error);
      setLoading(false);
      setByOrderIdData({error: error.response?.data})
    }
  };
  fetchByOrderId();
};

export const fetchBidsData = async ({ setBidsData }) => {
  try {
    const data = await quoteService.getBids();

    setBidsData(data);
  } catch (error) {
    console.error("Error getting data:", error);
  }
};

export const getTruck = ({ title, setValue, setTruckType, state }) => {
  if(state?.dispatched) {
    quoteService.getTruckCompactDispatched({ truck_plate_number: title }).then(
      ({ data }) => {
        const { height, length, width, truck_type } = data || {};
        setValue("height", height);
        setValue("length", length);
        setValue("width", width);
        setValue("truckType", truck_type);
        setTruckType({ name: { title: truck_type, value: truck_type } });
      },
      ({ response }) => {
        console.error(response);
      },
    );
  } else {
    quoteService.getTruckCompact({ truck_plate_number: title }).then(
      ({ data }) => {
        const { height, length, width, truck_type } = data || {};
        setValue("height", height);
        setValue("length", length);
        setValue("width", width);
        setValue("truckType", truck_type);
        setTruckType({ name: { title: truck_type, value: truck_type } });
      },
      ({ response }) => {
        console.error(response);
      },
    );
  }
};
